import { Text } from '@factorialco/deprecated-design-system'

import Compensation from 'modules/contracts/store/models/Compensation'
import type SupplementForm from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/SupplementForm'

interface AmountInputIndicatorProps {
  form: SupplementForm
  isCalculationOrPaid: boolean
  percentageNumber: number
}

const AmountInputIndicator = ({
  form,
  isCalculationOrPaid,
  percentageNumber,
}: AmountInputIndicatorProps) => {
  if (form.compensationType === Compensation.types.up_to) {
    if (form.get('amount_in_cents').value) {
      return <Text.Normal color="grey600">{`(${percentageNumber}%)`}</Text.Normal>
    } else if (isCalculationOrPaid) {
      return <Text.Normal color="grey600">{`(0%)`}</Text.Normal>
    }
  }

  return null
}

export default AmountInputIndicator
